// Convention:
// - Everything lowercase is an object
// - Everything uppercase is a string (the route)

import { keys } from '../keys';

export const baseUrl = {
  Marketing: keys().NEXT_PUBLIC_MARKETING_URL
} as const;

export const routes = {
  marketing: {
    Contact: `${baseUrl.Marketing}/contact`,
    CookiePolicy: `${baseUrl.Marketing}/cookie-policy`,
    Index: `${baseUrl.Marketing}/`,
    PrivacyPolicy: `${baseUrl.Marketing}/privacy-policy`,
    TermsOfUse: `${baseUrl.Marketing}/terms-of-use`
  }
} as const;

export function getPathname(route: string, baseUrl: string): string {
  return new URL(route, baseUrl).pathname;
}
